import React from 'react';
import PopupContext from 'src/contexts/PopupContext';

const usePopup = () => React.useContext(PopupContext);

export default usePopup;
